<template>
  <div>
    <v-app-bar
      app
      tile
      height="50px"
      color="white"
      :style="{
        left: '240px',
      }"
    >
      <v-spacer></v-spacer>

      <button
        class="btn mr-5"
        style="height: 32px"
        @click="isSwitchLanguageShow = !isSwitchLanguageShow"
      >
        <v-icon
          class="mr-2"
          :style="{
            'font-size': '20px',
            transform: 'translateY(0.3px)',
          }"
          >language</v-icon
        >
        <span class="mr-2">{{ local.display_name }}</span>
      </button>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2"
            v-bind="attrs"
            v-on="on"
            :style="{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              color: '#ffffff',
              'min-width': 0,
              backgroundColor: '#1e50c0',
            }"
          >
            JB
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            link
          >
            <v-list-item-title>修改密碼</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
          >
            <v-list-item-title @click="onLogout">登出</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <SwitchLanguage
      :isShow="isSwitchLanguageShow"
      @cancel-event="isSwitchLanguageShow = !isSwitchLanguageShow"
      @confirm-event="isSwitchLanguageShow = !isSwitchLanguageShow"
    >
    </SwitchLanguage>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SwitchLanguage from '@/views/Z-1__SystemFunction/Z-1_Switch-Language-Country.vue';

export default {
  name: 'NavBar',
  data: () => ({
    isSwitchLanguageShow: false,
    selectedLanguage: '台灣',
  }),
  components: {
    SwitchLanguage,
  },
  computed: {
    ...mapGetters([
      'local',
    ]),
  },
  methods: {
    ...mapActions(['logout']),
    onLogout() {
      this.logout();
      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<style></style>
